import { ButtonProps } from '@mui/material/Button';

import ButtonStyle from './style';

const Button = ({ children, ...props }: ButtonProps) => <ButtonStyle {...props}>{children}</ButtonStyle>;

export default Button;
